@if (editedFees().length > 0) {
	<section class="container">
		<div class="divider">
			<h2 class="secondary-header">Fees and funding</h2>
			<div
				class="border-b sm:border sm:border-gray-200 sm:overflow-hidden sm:rounded-lg sm:mx-0"
			>
				<div class="overflow-x-auto align-middle">
					<table class="min-w-full text-left divide-y divide-gray-200">
						<thead class="bg-gray-50">
							<tr class="hidden sm:table-row">
								<th
									scope="col"
									class="px-6 py-4 pr-0 text-sm font-bold tracking-wider text-gray-500 uppercase sm:pr-6 min-w-[250px]"
								>
									Region
								</th>
								<th
									scope="col"
									class="px-6 py-3 pr-0 text-sm font-bold tracking-wider text-left text-gray-500 uppercase sm:pr-6"
									[ngClass]="{
										'cursor-pointer': editedFees().length > 1,
									}"
									(click)="onSortFees(!sortAscend)"
								>
									<div class="flex items-center justify-start">
										<span>Costs</span>
										@if (editedFees().length > 1) {
											<span>
												@if (sortAscend()) {
													<uc-sort-descending-svg />
												} @else {
													<uc-sort-ascending-svg />
												}
											</span>
										}
									</div>
								</th>
								<th
									scope="col"
									class="px-6 py-3 text-sm font-bold tracking-wider text-left text-gray-500 uppercase sm:pr-6 min-w-[180px]"
								>
									Academic Year
								</th>
								<th
									scope="col"
									class="px-6 py-3 text-sm font-bold tracking-wider text-gray-500 uppercase sm:pr-6"
								>
									Year
								</th>
								@if (isFeatured()) {
									<th
										scope="col"
										class="px-6 py-3 text-sm font-bold tracking-wider text-gray-500 uppercase md:block sm:pr-6"
									></th>
								}
							</tr>
						</thead>
						<tbody class="divide-y divide-gray-20">
							@for (fee of editedFees(); track fee) {
								<tr class="bg-white">
									<td
										class="text-left sm:px-6 py-5 sm:py-8 pr-0 font-medium text-gray-500 sm:pr-6 whitespace-wrap text-base min-w-[250px]"
									>
										{{ fee[0] }}
									</td>
									<td
										class="py-5 pr-0 text-base font-medium text-left text-gray-900 sm:px-6 sm:py-8 sm:pr-6 whitespace-nowrap"
									>
										£{{ +fee[1] | number: '' : 'en-GB' }}
									</td>
									<td
										class="hidden py-5 text-base font-medium text-left text-gray-900 sm:px-6 sm:py-8 sm:table-cell sm:pr-6 whitespace-nowrap"
									>
										{{ currentYear }}/{{ nextYearTrail }}
									</td>
									<td
										class="hidden py-5 text-base font-medium text-gray-900 sm:px-6 sm:py-8 sm:table-cell sm:pr-6 whitespace-nowrap"
									>
										Year 1
									</td>
									@if (externalUrl() && isFeatured()) {
										<td
											class="hidden px-6 py-4 text-base font-medium text-gray-900 md:table-cell sm:pr-6 whitespace-nowrap"
										>
											<ng-container
												[ngTemplateOutlet]="visitWebsiteBtnRef"
												[ngTemplateOutletContext]="{
													$implicit: { fee },
												}"
											>
											</ng-container>
										</td>
									}
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
			@if (externalUrl() && isFeatured()) {
				<div class="pt-5 sm:pt-6 md:hidden">
					<ng-container
						[ngTemplateOutlet]="visitWebsiteBtnRef"
						[ngTemplateOutletContext]="{
							$implicit: { editedFees: editedFees() },
						}"
					></ng-container>
				</div>
			}
		</div>
	</section>
}
